import { IUser } from '../stores/usersStore'
import { IRoleEnum } from '../types/router'

import axiosAuth from './axiosAuth'

export const getUsers = (controller: AbortController) =>
    axiosAuth.get<IUser[]>('/users', {
        signal: controller.signal,
    })

export const deleteUser = (id: string) => axiosAuth.delete(`/users/${id}`)

export const putUser = (id: string, role: IRoleEnum) =>
    axiosAuth.put(`/users/${id}`, role)

export interface IAccount {
    id: string
    email: string
    username: string
    role: IRoleEnum
    capabilities: {
        can_delete_faq: boolean
    }
}

export const getMyAccount = (controller: AbortController) =>
    axiosAuth.get<IAccount>(`/account`, {
        signal: controller.signal,
    })
